import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from 'moment';
import {withRouter} from '@computerrock/formation-router';
import {useTranslate} from '@computerrock/formation-i18n';
import {useStyles, Panel, DataRow} from '@ace-de/ui-components';
import * as serviceCaseSelectors from '../../service-cases/serviceCaseSelectors';

const CommissioningPeopleOnSitePanel = ({serviceCase}) => {
    const {cx} = useStyles();
    const {createTranslateShorthand, translate} = useTranslate();
    const translateTab = createTranslateShorthand('sav_commissioning_tab');

    const formatChildrenAge = () => {
        let outputString = `${serviceCase.childrenAtSite}`;
        serviceCase.childrenAge.forEach((age, idx) => {
            if (idx === 0) {
                outputString = outputString.concat(' (');
            }
            outputString = idx === serviceCase.childrenAge.length - 1
                ? outputString.concat(`${age} ${translate('global.time_unit.year')})`)
                : outputString.concat(`${age} ${translate('global.time_unit.year')}, `);
        });
        return outputString;
    };

    return (
        <Panel
            title={translateTab('panel_title.people_on_site')}
            qaIdent="sav-commissioning-people-at-site"
        >
            <div className={cx('global!ace-u-two-column-layout')}>
                <div>
                    <DataRow
                        label={translateTab('data_row_label.adults')}
                        qaIdent="sa-commissioning-people-at-site"
                    >
                        {serviceCase.grownUpsAtSite}
                    </DataRow>
                    <DataRow
                        label={translateTab('data_row_label.pets')}
                        qaIdent="sa-commissioning-pets-at-site"
                    >
                        {serviceCase.petsAtSite}
                    </DataRow>
                </div>
                <div>
                    <DataRow
                        label={translateTab('data_row_label.children')}
                        qaIdent="sa-commissioning-children-at-site"
                    >
                        {formatChildrenAge()}
                    </DataRow>
                    <DataRow
                        label={translateTab('data_row_label.planned_departure')}
                        qaIdent="sc-planned-departure"
                    >
                        {serviceCase.departureDate ? moment(serviceCase.departureDate).format('DD.MM.YYYY') : '-'}
                    </DataRow>
                </div>
            </div>
        </Panel>
    );
};

CommissioningPeopleOnSitePanel.propTypes = {
    serviceCase: PropTypes.object,
};

CommissioningPeopleOnSitePanel.defaultProps = {
    serviceCase: null,
};

const mapStateToProps = (state, props) => {
    const serviceCaseSelector = serviceCaseSelectors.createServiceCaseSelector();
    return {
        serviceCase: serviceCaseSelector(state, props),
    };
};

export default withRouter(connect(mapStateToProps, null)(CommissioningPeopleOnSitePanel));

